import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnChooserSearch,
  HeaderFilter,
  ColumnFixing,
  Scrolling,
  StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "e7ac98b3-b444-445a-84c9-a11f1bd2ede1";

class PreviewUndoInvoices extends React.Component {
    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;
        console.log(this.props.dataSource);
        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }
    loadState() {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }
    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    height={'69vh'}
                    className="SearchOrderSalesResultOpenState"
                    scrolling={{ mode: "standard" }}
                    key={"rowid"}
                >
                    <Scrolling mode="virtual" />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={20} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column dataField="invoicenumber" caption="Invoice Number" allowEditing={false}></Column>
                    <Column dataField="invoicedate" caption="Invoice Date" dataType={"date"} format="MM/dd/yyyy" allowEditing={false}></Column>
                    <Column dataField="customer" caption="Customer" allowEditing={false}></Column>
                    <Column dataField="customername" caption="Customer Name" allowEditing={false}></Column>
                    <Column dataField="referencenumber" caption="Reference Number" allowEditing={false}></Column>
                </DataGrid>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PreviewUndoInvoices);